"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../v2/PhoneNumberForm/index.scss");
const CountryCode_1 = __importDefault(require("@App/kit/fields/PhoneNumberForm/CountryCode"));
const AreaCode_1 = __importDefault(require("@App/kit/fields/PhoneNumberForm/AreaCode"));
const LineNumber_1 = __importDefault(require("@App/kit/fields/PhoneNumberForm/LineNumber"));
const react_hook_form_1 = require("react-hook-form");
const utils_1 = require("@App/common/utils");
const phone_number_form_1 = require("@App/forms/common/phone-number-form");
const contexts_1 = require("@App/contexts");
const validate_1 = require("@App/helpers/validate");
const error_messages_1 = require("@Const/error-messages");
const PhoneNumberForm = (props) => {
    const { libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { phoneNumberFormProps, optional } = props;
    const [phoneNumberFormFields, setPhoneNumberFormFields] = (0, react_1.useState)(phoneNumberFormProps);
    const [numberIsOptional, setNumberIsOptional] = (0, react_1.useState)(!!optional);
    const { watch } = (0, react_hook_form_1.useFormContext)();
    const countryValue = watch(phoneNumberFormFields.phoneCountryCode.name);
    (0, react_1.useEffect)(() => {
        if (phoneNumberFormFields.phoneAreaCode.registerOptions) {
            if ((0, utils_1.isPhoneCodeUS)(countryValue)) {
                phoneNumberFormFields.phoneAreaCode.registerOptions = Object.assign(Object.assign({}, phoneNumberFormFields.phoneAreaCode.registerOptions), { minLength: {
                        value: 3,
                        message: `${error_messages_1.MIN_LENGTH_MESSAGE} 3`,
                    } });
            }
            phoneNumberFormFields.phoneAreaCode.registerOptions = (0, validate_1.setRequiredIfTrue)((0, utils_1.isPhoneCodeUS)(countryValue), phoneNumberFormFields.phoneAreaCode.registerOptions);
        }
        if (phoneNumberFormFields.phoneNumber.registerOptions) {
            if ((0, utils_1.isPhoneCodeUS)(countryValue)) {
                phoneNumberFormFields.phoneNumber.registerOptions = Object.assign(Object.assign({}, phoneNumberFormFields.phoneNumber.registerOptions), { minLength: {
                        value: 7,
                        message: `${error_messages_1.MIN_LENGTH_MESSAGE} 7`,
                    } });
            }
        }
        setPhoneNumberFormFields(Object.assign({}, phoneNumberFormFields));
    }, [countryValue]);
    if (optional) {
        const areaCodeValue = watch(phoneNumberFormFields.phoneAreaCode.name);
        const lineNumberValue = watch(phoneNumberFormFields.phoneNumber.name);
        (0, react_1.useEffect)(() => {
            if (countryValue || areaCodeValue || lineNumberValue) {
                setNumberIsOptional(false);
            }
            else {
                setNumberIsOptional(true);
            }
        }, [countryValue, areaCodeValue, lineNumberValue]);
        (0, react_1.useEffect)(() => {
            const formFields = (0, phone_number_form_1.markFieldAsRequired)(phoneNumberFormFields, numberIsOptional);
            setPhoneNumberFormFields(Object.assign({}, formFields));
        }, [numberIsOptional]);
    }
    phoneNumberFormFields.phoneCountryCode.options = libStore.phoneCountryCodes;
    return (react_1.default.createElement("div", { className: "phone-number-form-component" },
        react_1.default.createElement("label", { className: "small main-phone-label" }, "Phone Number"),
        react_1.default.createElement("div", { className: "phone-inputs-block" },
            react_1.default.createElement(CountryCode_1.default, Object.assign({}, phoneNumberFormFields.phoneCountryCode)),
            react_1.default.createElement(AreaCode_1.default, Object.assign({}, phoneNumberFormFields.phoneAreaCode)),
            react_1.default.createElement(LineNumber_1.default, Object.assign({}, phoneNumberFormFields.phoneNumber)))));
};
exports.default = PhoneNumberForm;
